import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useToggle, useMeasure } from 'react-use';
import { Anchor } from 'app/components/InPageNavigation';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {
  AccordionContentStyle,
  AccordionHeaderStyle,
  AccordionStyle,
} from 'app/components/Accordion/style';

export interface AccordionProps {
  label: string;
  content: string | JSX.Element | JSX.Element[];
  id?: string;
  children?: ReactNode;
  onClick?: Function;
  expanded?: boolean;
}

export interface ContentProps {
  label: string;
  content: string;
}

export const Accordion = (props: AccordionProps) => {
  const location = useLocation();
  const [ref, { height }] = useMeasure<HTMLDivElement>();
  const [accordionState, setAccordionState] = useToggle(false);

  React.useEffect(() => {
    if (location.hash === `#${props.id}`) {
      setAccordionState(true);
    }
  }, []);

  return (
    <>
      <Anchor id={props.id} positionRelativeToTop={64} />
      <div
        css={AccordionStyle}
        style={{
          height: props.expanded || accordionState ? height + 80 : '48px',
          borderRadius:
            props.expanded || accordionState ? '0px 0px 16px 16px' : '0px',
          transition: 'height 150ms cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          data-expanded={props.expanded ? props.expanded : accordionState}
          id={props.id ? props.id : ''}
          onClick={(e) =>
            props.onClick
              ? props.onClick(e)
              : setAccordionState(!accordionState)
          }
          css={AccordionHeaderStyle}
        >
          {props.label}
          {props.expanded || accordionState ? (
            <ExpandLessIcon />
          ) : (
            <ExpandMoreIcon />
          )}
        </div>
        <div css={AccordionContentStyle} ref={ref}>
          {props.content}
        </div>
      </div>
    </>
  );
};
